import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby'
import StoreContext from 'src/context/StoreContext'
// import { GatsbyImage } from 'gatsby-plugin-image'
import RedesignCalendarTestimonials from '../components/RedesignCalendarTestimonials'

import SEO from '../components/seo'
import FramePress from '../components/FramePress'
import FAQs from '../components/FAQs'
import EffortlessToUse from '../components/EffortlessToUse'
import FreeReturns from '../components/FreeReturns'
import CalendarMaxFeatures from '../components/CalendarMaxFeatures'
import { HideOverflow } from '../utils/styles/global-styles'
import Analytics from '../utils/Analytics'
import FrameTable from '../components/FrameTable'
import GallerySlider from '../components/GallerySlider'
import SnapFrame from '../components/SnapFrame'
// import { BogoFrameContainer } from '../components/Hero/styles'
import HomepageCalHero from '../components/HomepageCalHero'
import SeasonalCountdownTimer from '../components/SeasonalCountdownTimer'
import {
  VIP_CODE,
  SEASONAL_STATES,
  CURRENT_SEASONAL_STATE,
  IN_SEASONAL_STATE,
  COUNTDOWN_EXPIRATIONS,
  LOCALIZATION,
  IS_FRAME_SALE,
} from '../utils/constants'

class Frame2Page extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCountdownVisible: false,
    }

    this.handleCountdownComplete = this.handleCountdownComplete.bind(this)
    this.renderCountdown = this.renderCountdown.bind(this)
  }

  componentDidMount() {
    Analytics.track('Viewed Frame 2 Landing Page')
    const { checkUtmParamsForPromo } = this.context
    checkUtmParamsForPromo(window.location.search)
    if (IN_SEASONAL_STATE || IS_FRAME_SALE) this.setState({ isCountdownVisible: true })
    const { countdownData, countdownCountry } = this.state
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const showCountdown = promoCode === VIP_CODE
    const holidayDate = countdownData?.[countdownCountry] || countdownData?.en_countdown
    const hasHoliday = holidayDate && holidayDate !== 'NONE'
    if (showCountdown || hasHoliday) {
      this.setState({ isCountdownVisible: true })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const showCountdown = promoCode === VIP_CODE
    if (showCountdown && !prevState.isCountdownVisible) {
      this.setState({ isCountdownVisible: true })
    }
  }

  handleCountdownComplete() {
    this.setState({ isCountdownVisible: false })
  }

  renderCountdown(holidayDate) {
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const { bfcmCore, vip } = SEASONAL_STATES

    if (IN_SEASONAL_STATE || (IS_FRAME_SALE && CURRENT_SEASONAL_STATE !== 'vip')) {
      return (
        <SeasonalCountdownTimer
          holidayDate={holidayDate}
          holidayState={CURRENT_SEASONAL_STATE ?? bfcmCore}
          onCountdownComplete={this.handleCountdownComplete}
          marginTop
          frame
          frame2
        />
      )
    }

    if (promoCode === VIP_CODE) {
      return (
        <SeasonalCountdownTimer
          holidayDate={holidayDate}
          holidayState={vip}
          onCountdownComplete={this.handleCountdownComplete}
          marginTop
          frame
          frame2
        />
      )
    }
  }

  render() {
    const { t, data } = this.props
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context

    const frame2Image = data?.frame2Image
    const { isCountdownVisible } = this.state
    const countdownCountry = `${LOCALIZATION.replace(/-/g, '_')}_countdown`
    const isVIPState = promoCode === VIP_CODE && !IN_SEASONAL_STATE

    const vipHolidayDate = isVIPState ? COUNTDOWN_EXPIRATIONS?.vip?.[countdownCountry] : null
    const countdownData = COUNTDOWN_EXPIRATIONS?.bfcm
    const holidayDate =
      vipHolidayDate ?? (countdownData?.[countdownCountry] || countdownData?.en_countdown)
    // const bogoImage = data?.bogo
    const heroVersion = IN_SEASONAL_STATE ? 'bfcmFrame2' : isVIPState ? 'bfcmFrame2' : 'frame2'

    return (
      <>
        <SEO
          title={t('Skylight Frame 2 | Skylight Frame')}
          description={t(
            'Interchangeable frames, higher resolution screen, more onboard storage and free videos and captions. Give The Perfect Gift — Shop The Smart Digital Frame 2'
          )}
          canonicalPath="/frame-2/"
          imagePath={frame2Image.childImageSharp.gatsbyImageData.images.fallback.src}
          path="/frame-2/"
        />
        <Helmet>
          <meta charset="UTF-8" />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
          />
        </Helmet>
        <HideOverflow>
          <HomepageCalHero page={heroVersion} />
          {/* <BogoFrameContainer>
            <GatsbyImage
              image={bogoImage.childImageSharp.gatsbyImageData}
              alt="Buy One Get One 40% off any Frame"
            />
          </BogoFrameContainer> */}
          {isCountdownVisible && holidayDate && this.renderCountdown(holidayDate)}
          <FramePress frame2 />
          <EffortlessToUse title={t('Easy to Use. Easy to Love.')} />
          <CalendarMaxFeatures page="frame" cream />
          <FrameTable />
          <GallerySlider />
          <HideOverflow>
            <RedesignCalendarTestimonials frame />
          </HideOverflow>
          <SnapFrame />
          <FreeReturns />
          <FAQs page="frame" />
        </HideOverflow>
      </>
    )
  }
}

Frame2Page.propTypes = {
  t: PropTypes.func,
  data: PropTypes.object.isRequired,
}

Frame2Page.contextType = StoreContext

export default withTranslation()(Frame2Page)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["common", "frame"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    frame2Image: file(relativePath: { eq: "frame2/frame-2-wood-mom-and-baby-mobile.webp" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    countdown: allContentfulCountdownTimer {
      edges {
        node {
          en_au_countdown
          en_ca_countdown
          en_countdown
          en_gb_countdown
        }
      }
    }
    bogo: file(relativePath: { eq: "frame-bogo-badge.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE)
      }
    }
  }
`
